import {
	WIDGET_WIDTH,
	WIDGET_DEFAULT_TOP_OFFSET,
	WIDGET_DEFAULT_RIGHT_INSET,
} from './widgetLayout'

const TRIGGER_SELECTOR = '[data-note-taker-trigger]'
const TRIGGER_GAP = 8

function clamp(value, min, max) {
	return Math.min(Math.max(value, min), max)
}

export function getDefaultWidgetPosition(railWidth) {
	return {
		left: Math.max(0, railWidth - WIDGET_WIDTH - WIDGET_DEFAULT_RIGHT_INSET),
		verticalAnchor: 'top',
		verticalOffset: WIDGET_DEFAULT_TOP_OFFSET,
	}
}

export function getDefaultWidgetPositionUnderTrigger(railRect, height) {
	const trigger = document.querySelector(TRIGGER_SELECTOR)
	if (!trigger) {
		return getDefaultWidgetPosition(railRect.width)
	}

	const triggerRect = trigger.getBoundingClientRect()
	const left = clamp(
		triggerRect.right - railRect.left - WIDGET_WIDTH,
		0,
		railRect.width - WIDGET_WIDTH,
	)
	const verticalOffset = clamp(
		triggerRect.bottom - railRect.top + TRIGGER_GAP,
		0,
		Math.max(0, railRect.height - height),
	)

	return { left, verticalAnchor: 'top', verticalOffset }
}

export function positionFromTopLeft(left, top, railWidth, railHeight, height, options = {}) {
	const { preferTopAnchor = false } = options
	const clampedLeft = clamp(left, 0, railWidth - WIDGET_WIDTH)
	const maxTop = Math.max(0, railHeight - height)
	const clampedTop = clamp(top, 0, maxTop)
	const distanceToBottom = railHeight - (clampedTop + height)

	if (!preferTopAnchor && distanceToBottom <= clampedTop) {
		return {
			left: clampedLeft,
			verticalAnchor: 'bottom',
			verticalOffset: distanceToBottom,
		}
	}

	return {
		left: clampedLeft,
		verticalAnchor: 'top',
		verticalOffset: clampedTop,
	}
}

export function positionToTopOffset(position, height, railHeight) {
	if (!position) return 0
	if (position.verticalAnchor === 'bottom') {
		return Math.max(0, railHeight - height - position.verticalOffset)
	}
	return position.verticalOffset
}

export function positionFromRect(rect, railRect, height) {
	const left = rect.left - railRect.left
	const top = rect.top - railRect.top
	return positionFromTopLeft(left, top, railRect.width, railRect.height, height)
}

export function fitWidgetPosition(position, height, railWidth, railHeight) {
	if (!position) {
		return getDefaultWidgetPosition(railWidth)
	}

	const maxLeft = Math.max(0, railWidth - WIDGET_WIDTH)
	let { left, verticalAnchor, verticalOffset } = position

	left = clamp(left, 0, maxLeft)

	if (verticalAnchor === 'bottom') {
		const maxBottomOffset = Math.max(0, railHeight - height)
		verticalOffset = clamp(verticalOffset, 0, maxBottomOffset)
	} else {
		verticalOffset = clamp(verticalOffset, 0, Math.max(0, railHeight - height))
	}

	return { left, verticalAnchor, verticalOffset }
}
